// removed by extract-text-webpack-plugin
module.exports = {"root":"Dialogue_root_3cY","inner":"Dialogue_inner_2z-","sender":"Dialogue_sender_1TV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Dialogue/Dialogue.css
 ** module id = 566
 ** module chunks = 0
 **/